type WorkaroundWarningResult = {
  hasUpdatedWorkarounds: boolean;
  count: number;
};

type WorkaroundEntity<T> = {
  uuid: string;
  workaroundUpdatedAt: string | null;
  itApplicationId: string;
  [key: string]: any;
} & T;

/**
 * Checks if removing IT applications would result in losing updated workarounds
 * @param workarounds - Array of current workarounds
 * @param appsBeingRemoved - Array of IT applications that are being removed
 * @returns Object containing whether there are updated workarounds being removed and the count
 */
export const checkForWorkaroundsAffectedByITAppRemoval = <T>(
  workarounds: WorkaroundEntity<T>[],
  appsBeingRemoved: { uuid: string }[],
): WorkaroundWarningResult => {
  // Convert the list of apps being removed into a Set for faster lookups
  const removedAppIds = new Set(appsBeingRemoved.map((item) => item.uuid));

  // Find workarounds for items being removed that have been updated
  const affectedWorkarounds = workarounds.filter(
    (workaround) =>
      removedAppIds.has(workaround.itApplicationId) && // Item is being removed
      workaround.workaroundUpdatedAt !== null, // Workaround has been updated
  );

  return {
    hasUpdatedWorkarounds: affectedWorkarounds.length > 0,
    count: affectedWorkarounds.length,
  };
};
